import { SVGInterface } from "../../interface";

const CircleCheckFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5203 21.9939 21.9939 17.5203 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM18 9.00004L16.59 7.58008L10 14.1701L7.41 11.5901L6.00004 13L10 17.0001L18 9.00004Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CircleCheckFilled;
